import ActionTypes from "../constants/action_types";

export default function clearDocuments(organisationId, projectId) {
  return {
    type: ActionTypes.DOCUMENTS_CLEAR.SUCCESS,
    organisation_id: organisationId,
    project_id: projectId,
  };
}
